import { generateBaseQueryKeysList } from '@/queries/utils';

export const NOTIFICATIONS_SETTINGS_KEYS = {
  main: 'notifications-settings',
};

export const personalizationQueryKeys = generateBaseQueryKeysList(NOTIFICATIONS_SETTINGS_KEYS.main);
